import React from 'react';

import { HoverCard, HoverCardContent, HoverCardTrigger } from 'components/ui/hover-card';
import { ChevronDownIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useRouteChangeHandler } from 'shared/hooks';

type DropdownMenuProps = {
  title: string;
  gaLabel?: string;
  subMenu: { to: string; title: string; target?: string; gaLabel?: string; external?: boolean }[];
};

function DropdownMenu({ title, gaLabel, subMenu }: DropdownMenuProps) {
  const { handleRouteChange } = useRouteChangeHandler();
  const { lang } = useParams<{ lang?: string }>();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, to: string, menuName: string) => {
    e.preventDefault();

    window.dataLayer?.push({
      event: 'click_menu',
      menu: menuName,
      section: gaLabel ?? title,
    });

    if (to) {
      handleRouteChange(to);
    }
  };

  return (
    <li tabIndex={0}>
      <HoverCard openDelay={0} closeDelay={50}>
        <HoverCardTrigger className="flex cursor-pointer items-center gap-1 rounded-lg px-3 py-[6px] text-b3 hover:bg-[#F6F6F6]">
          <span>{title}</span>
          <ChevronDownIcon className="size-4" />
        </HoverCardTrigger>

        <HoverCardContent className="w-[200px] rounded-lg border-none bg-white p-0 shadow-[0px_3px_12.1px_0px_rgba(0,0,0,0.14)]">
          <div className="flex flex-col px-2 py-1.5">
            {subMenu.map(({ to, title: itemTitle, target, gaLabel: itemGaLabel, external }) => (
              <div
                key={to}
                className="text-b6 cursor-pointer rounded-md px-2 py-1.5 hover:bg-[#F8F8F8]"
                onClick={(e) => {
                  if (target === '_blank') {
                    window.dataLayer?.push({
                      event: 'click_menu',
                      menu: itemGaLabel ?? itemTitle,
                      section: gaLabel ?? title,
                    });
                    window.open(to, '_blank', 'noopener,noreferrer');
                  } else if (external) {
                    window.dataLayer?.push({
                      event: 'click_menu',
                      menu: itemGaLabel ?? itemTitle,
                      section: gaLabel ?? title,
                    });
                    window.location.href = lang ? `/${lang}${to}` : to;
                  } else {
                    handleClick(e as unknown as React.MouseEvent<HTMLAnchorElement>, to, itemGaLabel ?? itemTitle);
                  }
                }}
              >
                {itemTitle}
              </div>
            ))}
          </div>
        </HoverCardContent>
      </HoverCard>
    </li>
  );
}

export default DropdownMenu;
